<template>
  <div class="deck-embed">
    <div class="deck-frame" :class="{ 'demo-active': demoActive }" ref="deckFrame">
      <iframe
        ref="deckIframe"
        src="https://www.henryw.me/CCGL9074/"
        title="Live scrollytelling deck built on the engine"
        loading="lazy"
        :tabindex="!demoActive ? -1 : 0"
        :inert="!demoActive"
      ></iframe>
      <DemoInteractionGate
        :active="demoActive"
        label="Explore this story"
        open-href="https://www.henryw.me/CCGL9074/"
        @activate="activateDemo"
        @deactivate="deactivateDemo"
      />
    </div>
  </div>
</template>

<script>
import DemoInteractionGate from '../ui/DemoInteractionGate.vue';

export default {
  name: 'LiveDeckEmbed',
  components: { DemoInteractionGate },
  data() {
    return { demoActive: false };
  },
  mounted() {
    this._onDeckResize = () => {
      cancelAnimationFrame(this._deckResizeFrame);
      this._deckResizeFrame = requestAnimationFrame(() => this.scaleDeck());
    };
    window.addEventListener('resize', this._onDeckResize);
    if (typeof ResizeObserver !== 'undefined') {
      this._deckObserver = new ResizeObserver(this._onDeckResize);
      this._deckObserver.observe(this.$refs.deckFrame);
    }
    this.$nextTick(() => this.scaleDeck());
  },
  unmounted() {
    if (this._onDeckResize) window.removeEventListener('resize', this._onDeckResize);
    this._deckObserver?.disconnect();
    cancelAnimationFrame(this._deckResizeFrame);
  },
  methods: {
    activateDemo() {
      this.demoActive = true;
      this.$nextTick(() => this.$refs.deckIframe?.focus({ preventScroll: true }));
    },
    deactivateDemo() { this.demoActive = false; },
    scaleDeck() {
      const frame = this.$refs.deckFrame;
      const iframe = this.$refs.deckIframe;
      if (!frame || !iframe) return;
      const DESIGN_W = 1200;
      const DESIGN_H = 750;
      const cw = frame.clientWidth;
      if (!cw || cw === this._deckWidth) return;
      this._deckWidth = cw;
      const scale = cw / DESIGN_W;
      iframe.style.width = `${DESIGN_W}px`;
      iframe.style.height = `${DESIGN_H}px`;
      iframe.style.transform = `scale(${scale})`;
      frame.style.height = `${Math.round(DESIGN_H * scale)}px`;
    },
  },
};
</script>

<style scoped>
.deck-embed {
  --frame-open-line: rgba(255, 255, 255, 0.09);
  --frame-open-muted: #9a9a9a;
  --frame-open-ink: #e8e8e8;
  --frame-open-hover: rgba(255, 255, 255, 0.05);
  --frame-open-press: rgba(255, 255, 255, 0.09);
  margin: 1.2rem 0 0;
  border: 1px solid #e3e3ea;
  border-radius: 12px;
  overflow: hidden;
  background: #0e0e12;
}
.deck-frame {
  position: relative;
  isolation: isolate;
  width: 100%;
  overflow: clip;
}
.deck-embed iframe {
  display: block;
  width: 100%;
  height: clamp(420px, 78vh, 760px);
  border: 0;
  transform-origin: top left;
}

body.dark-mode .deck-embed {
  border-color: #2e2e34;
}
.deck-frame iframe { pointer-events: none; }
.deck-frame.demo-active iframe { pointer-events: auto; }
</style>
